<bz-dialog-layout [heading]="data.title">
  <div bzDialogContent>{{ data.message }}</div>

  <div bzDialogActions>
    @if (isAlert) {
      <!-- Spacer so the lone action sits right, the same `<span flex>` idiom
           the console's own dialog footers use. -->
      <span></span>
    } @else {
      <bz-button variant="tertiary" type="button" (clicked)="close(false)">
        {{ data.cancelLabel || 'Cancel' }}
      </bz-button>
    }
    <bz-button
      type="button"
      [tone]="data.destructive ? 'danger' : 'secondary'"
      (clicked)="close(true)"
    >
      {{ data.confirmLabel || (isAlert ? 'OK' : 'Confirm') }}
    </bz-button>
  </div>
</bz-dialog-layout>
